import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { snackActions } from '../../SnackbarUtilsConfigurator'
import { ImmagineRequest, ImmaginiResponse, ImmaginiResponseDelete, ImmaginiResponseInsert } from './immaginiSlice'

export const immaginiApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT + '/image' }),
    reducerPath: 'immaginiApi',
    tagTypes: ['immagini'],
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        immagini: build.query<ImmaginiResponse, ImmagineRequest>({
            keepUnusedDataFor: 0.1,
            query: ({ id, TIPO }) => `/images?id=${id}&TIPO=${TIPO}`,
            transformResponse: (response: ImmaginiResponse, meta, arg) => {
                return response
            },
            providesTags: ['immagini'],
        }),
        insertPost: build.mutation<ImmaginiResponseInsert, ImmagineRequest>({
            query: (body) => ({
                url: `/`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['immagini'],
        }),
        deletePost: build.mutation<ImmaginiResponseDelete, ImmagineRequest>({
            query: (body) => ({
                url: `/`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['immagini'],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useImmaginiQuery, useDeletePostMutation, useInsertPostMutation } = immaginiApi

// -------------------------------------------------------------------
// GENERIC METHOD UPLOAD IMAGES - avoid refresh camera/video component
// -------------------------------------------------------------------

export const uploadImage = (
    id: string,
    DOC_ID: string,
    TIPO: string,
    AZIENDA_ID: number,
    COD_TIPO_IMAGE_DOC: string,
    image: string,
    callback: (image: ImmagineRequest) => void
) => {
    // const image = filesContent[0].content
    // const image = await plainFiles[0].arrayBuffer()
    const img = new Image()
    img.src = image
    img.onload = function () {
        const currImg = this as HTMLImageElement
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        const height = currImg.naturalHeight
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        const width = currImg.naturalWidth

        // -----------------------------------------------------------------

        snackActions.info('Caricamento immagine in corso...')

        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id,
                DOC_ID,
                TIPO,
                AZIENDA_ID: AZIENDA_ID,
                COD_TIPO_IMAGE_DOC,
                IMMAGINE: image,
                IMAGE_WIDTH: String(width),
                IMAGE_HEIGHT: String(height),
            }),
        }
        fetch(`${process.env.REACT_APP_ENDPOINT}/image`, requestOptions)
            .then((response) => {
                snackActions.success('Inserita correttamente')
                return response.json()
            })
            .then((response) => {
                const image = response.image as ImmagineRequest
                callback(image)
            })
            .catch((error) => {
                snackActions.error(error.message)
            })
    }
}
